
import React from 'react';
import './chip.css';

const Chip = ({ label }) => <p className='chip'>{label}</p>;

export default Chip;